var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ajaxOverlay"}},[_c('font-awesome-icon',{staticClass:"fa-spin fa-3x fa-fw",attrs:{"icon":"circle-notch"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }